<template>
  <div ref="viewer-container" id="viewer-container">
    <div id="viewer" class="pdfViewer"></div>
  </div>
</template>

<script>
import "pdfjs-dist/web/pdf_viewer.css";
export default {
  name: "PdfViewer",
  props: {
    url: String
  },
  data() {
    return {
      loadingTask: null
    };
  },
  mounted() {
    this.fetchPDF(this.url);
  },
  methods: {
    // 获取并渲染pdf
    async fetchPDF(url) {
      if (this.loadingTask) {
        await this.close();
      }

      const container = document.getElementById("viewer-container");
      const pdfjsViewer = await import("pdfjs-dist/web/pdf_viewer.js");
      const pdfLinkService = new pdfjsViewer.PDFLinkService({
        externalLinkTarget: 2
      });
      this.pdfLinkService = pdfLinkService;
      const pdfViewer = new pdfjsViewer.PDFViewer({
        container,
        linkService: pdfLinkService
      });

      pdfLinkService.setViewer(pdfViewer);

      const pdfFindController = new pdfjsViewer.PDFFindController({
        linkService: pdfLinkService,
        pdfViewer
      });
      pdfFindController.scrollMatchIntoView = () => {
        this.processScroll = true;
      };
      pdfViewer.findController = pdfFindController;
      this.pdfFindController = pdfFindController;

      const pdfjsLib = await import(
        /* webpackChunkName: 'pdfjs-dist' */ "pdfjs-dist/webpack.js"
      );
      this.loadingTask = pdfjsLib.getDocument({
        url,
        cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.2.228/cmaps/",
        cMapPacked: true,
        /* withCredentials: true,
        httpHeaders: {
          timestamp: "",
          signature: "",
          token: ""
        } */
      });
      const pdfDocument = await this.loadingTask.promise;
      this.pdfDocument = pdfDocument;
      this.pdfViewer = pdfViewer;
      pdfViewer.setDocument(pdfDocument);
      pdfLinkService.setDocument(pdfDocument);
      document.addEventListener('pagesinit', function () {
        // We can use pdfViewer now, e.g. let's change default scale.
        pdfViewer.currentScaleValue = 'page-width';
      });
    }
  },
  watch: {
    url: {
      handler(val) {
        this.fetchPDF(val);
      }
    }
  }
};
</script>

<style scoped>

</style>
